<template>
  <div>
    <el-form-item :label="label" :prop="propName" :class="{ 'is-required': required }">
      <el-upload
        v-show="!blobSrc && !rawSrc && !outputSrc"
        drag
        :http-request="choiceOver"
        action=""
        :show-file-list="false"
        accept="video/*"
      >
        <i class="el-icon-upload"/>
        <div class="el-upload__text">将视频文件拖动至此处，或 <em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          视频上传后系统将在后台自动转码，转码耗时约视频时长的 0.5 ~ 1.5 倍
        </div>
      </el-upload>

      <el-input
        v-show="blobSrc && !rawSrc && !outputSrc"
        v-model="blobSrc"
        :readonly="true"
        :style="`width: ${width}`"
      >
      </el-input>

      <el-input v-show="rawSrc && !outputSrc"
                v-model="rawSrc"
                :readonly="true"
                :style="`width: ${width}`">
      </el-input>

      <el-input v-show="outputSrc"
                v-model="outputSrc"
                :readonly="true"
                :style="`width: ${width}`">
      </el-input>

      <div v-show="blobSrc || src || rawSrc" class="preview-box">
        <div class="video-preview-box">
          <video :src="src || rawSrc || blobSrc"
                 controls="controls"
                 @canplaythrough="getDuration"
                 @drop.prevent="drop"
                 @dragover.prevent
                 @dragenter.prevent="is_drag = true"
                 @dragleave="is_drag = false"
                 :class="`video${is_drag ? ' img-drag' : ''}`"
          />
          <el-progress
            v-show="isUploading"
            :percentage="progress"
            type="circle"
            class="img-put"
          />
          <div
            v-show="!isUploading && (!isEdit || (isEdit && isShowClose))"
            :class="`icon-close-box${isDeleting ? '' : ' pointer danger-color-hover'}`"
            @click="remove"
          >
            <v-icon v-if="isDeleting" name="loading" class="flex-center"/>
            <v-icon v-else name="close"/>
          </div>
        </div>
      </div>
      <div v-if="rawSrc || outputSrc" class="video-transcode-status">
        <el-tag v-if="!outputSrc" type="warning" size="mini">转码中</el-tag>
        <el-tag v-else type="success" size="mini">已转码</el-tag>
      </div>
      <div v-show="(rawSrc || outputSrc || src) && !isUploading" class="el-upload__tip video-replace-tip">
        拖动新{{label}}到视频区域替换，或
        <input
          ref="video"
          @change="upload($refs.video.files[0])"
          type="file"
          accept="video/*"
          style="display: none"
        />
        <el-button size="mini" type="text" @click="choice">点击选择文件替换</el-button>
      </div>
    </el-form-item>
  </div>
</template>

<script>
  import { videoCdnHost, videoHost, putVideo, deleteFiles } from '@/api/oss';
  import { checkTranscode } from '@/api/video';

  export default {
    props: {
      label: {
        type: String,
        default: '视频',
      },
      prefix: {
        type: String,
        default: 'dance',
      },
      propName: {
        type: String,
        default: 'raw_src',
      },
      value: {
        type: String,
        default: '',
      },
      src: {
        type: String,
        default: '',
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      isShowClose: {
        type: Boolean,
        default: false,
      },
      required: {
        type: Boolean,
        default: false,
      },
      width: {
        type: String,
        default: '100%',
      },
    },
    data: () => ({
      is_drag: false,
      isUploading: false,
      isDeleting: false,
      isEncoded: false,
      name: '',
      blobSrc: '',
      rawSrc: '',
      outputSrc: '',
      objectKey: '',
      garbageList: [],
      videoSize: '',
      progress: 0,
      duration: 0,
      formatDur: '',
      timeout: 0,
      interval: 0,
    }),
    watch: {
      value: {
        immediate: true,
        handler(e) {
          if (e === this.rawSrc) return;
          this.rawSrc = e;
          if (e.startsWith(videoHost) || e.startsWith(videoCdnHost)) {
            this.objectKey = e.replace(videoHost, '').replace(videoCdnHost, '');
          }
        },
      },
      src: {
        immediate: true,
        handler(e) {
          if (e === this.outputSrc) return;
          this.outputSrc = e;
        },
      },
      rawSrc(e) {
        this.$emit('input', e)
      },
      outputSrc(e) {
        this.$emit('srcChange', e);
      },
    },
mounted() {
      // 编辑页载入“已有 raw 但还没有转码输出”的视频时，主动查一次转码状态
      if (this.rawSrc && this.rawSrc.startsWith(videoHost) && !this.outputSrc) {
        this.handleCheckTranscode();
      }
    },
    methods: {
      formatSize(size) {
        return size > 1024 * 1024
          ? (Math.round(size * 100 / (1024 * 1024)) / 100 + 'MB')
          : (Math.round(size * 100 / 1024) / 100 + 'KB');
      },
      readerVideo(file) {// 预览视频
        this.duration = 0;
        this.formatDur = '';
        this.blobSrc = URL.createObjectURL(file);
        this.name = file.name;
        this.videoSize = this.formatSize(file.size);
        // 通知外层选中的本地视频文件（供视频封面组件自动截帧取图）
        this.$emit('fileChange', file);
      },
      clearSrc() {
        this.blobSrc = this.rawSrc = this.outputSrc = this.formatDur = '';
      },
      clearInterval() {
        clearInterval(this.interval);
        this.interval = 0;
      },
      async del() {
        if (this.isDeleting) return;

        const oldObjectKey = this.objectKey;
        this.isDeleting = true;
        this.clearInterval();
        const { isError } = await deleteFiles([oldObjectKey]);
        this.isDeleting = false;
        if (isError) return;

        if (oldObjectKey === this.objectKey) this.clearSrc();
      },
      close() {
        if (this.isDeleting) return;
        if (!this.objectKey) return this.clearSrc();
        if (!this.isEdit) return this.del();
        // 编辑模式不在这里删 OSS：替换/删除的旧文件由后端在同一保存事务写入 del_object_key，
        // 保留期（默认 7 天）内未恢复才由定时任务物理删除，避免误点即永久丢失。


        this.clearSrc();
      },
      // 用户主动移除视频：除清空自身外，一并通知外层（供封面组件清理截帧）
      remove() {
        this.close();
        this.$emit('fileChange', null);
      },
      getDuration(e){
        if (this.formatDur) return;

        this.duration = e.target.duration;
        let time = ~~e.target.duration,
          [h, m, s] = [~~(time / 3600), ~~(time % 3600 / 60), ~~(time % 60)];
        if (h) this.formatDur = h + '小时';
        if (m) this.formatDur += m + '分';
        if (s) this.formatDur += s + '秒';
      },
      async handleCheckTranscode() {
        const { isError, data } = await checkTranscode(this.rawSrc);

        if (isError) {
          this.clearInterval();
          this.$message.error('视频转码状态获取失败');
          return;
        }

        if (!data.src) return;

        this.clearInterval();
        this.outputSrc = data.src;// 设置为转码后的路径
        this.$message.success('系统已成功转码视频');
      },
      checkTranscode() {
        let wait = 0;
        this.timeout = setTimeout(() => {// 根据当前视频总时长 设定定时器 之后开始轮询当前视频转码状态
          this.interval = setInterval(() => {// 3秒一次
            if (wait > this.duration * 3000) return this.clearInterval();

            wait += 3000;
            this.handleCheckTranscode();
          }, 3000);
        }, this.duration * 0.5);
      },
      handleProgress(e) {
        this.progress = ~~(e.loaded / e.total * 100);
      },
      async upload(videoData) {
        if (this.isUploading) return;
        if (videoData.type.split('/')[0] !== 'video') return this.$message.error('请选择视频类型的文件');

        this.isUploading = true;
        this.close();
        this.readerVideo(videoData);

        const objectKey = await putVideo({
          bucket_prefix: this.prefix,
          videoData,
          onProgress: this.handleProgress,
        }).catch(e => { this.$message.error(e.message); });

        this.isUploading = false;
        if (!objectKey) return;

        this.progress = 0;
        this.objectKey = objectKey;
        this.rawSrc = videoHost + objectKey;
        this.$message.success('视频上传成功，系统将在后台自动完成转码');
        this.checkTranscode();
      },
      choice() {
        this.$refs.video.value = '';
        this.$refs.video.click();
      },
      choiceOver(file) {
        this.upload(file.file);
      },
      drop(e) {
        this.is_drag = false;
        this.upload(e.dataTransfer.files[0]);
      },
    },
    beforeDestroy() {
      clearTimeout(this.timeout);
      clearInterval(this.interval);
      // 注意：不在组件销毁时删 OSS。已保存或被替换的视频统一由后端 del_object_key 延迟清理，
      // 避免“点了删除但没保存/取消后跳走”就误删文件。
    }
  }
</script>

<style src="./index.css" scoped/>
